import { Dashboard } from 'components/Layout';
import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import api from 'api/api';
import { compose } from 'ramda';
import StoreProvider from 'components/StoreProvider/StoreProvider';
import { OrganizationType } from 'store/modules/organizations/organizations';
import Users from 'components/OrganizationAdmin/Projects/Shared/Users';
import Menu, { Tab } from './Menu';
import { BackTo } from '@deeptrue-frontend/ui';
import ROUTES from 'consts/routing';
import { ProjectType } from '../types';
import Groups from 'components/OrganizationAdmin/Projects/Shared/Groups';
import { useFormatMessage } from 'components/IntlProvider';

const { connect, selectors } = StoreProvider;

interface Props extends RouteComponentProps {
  organization: OrganizationType;
  match: {
    isExact: boolean;
    path: string;
    url: string;
    params: {
      id: string;
    };
  };
}

const ProjectSharingPage = ({
  location,
  organization,
  match,
  history,
}: Props) => {
  const [tab, selectTab] = useState<Tab>(
    location.search === '?tab=users' ? 'users' : 'groups'
  );
  const t = useFormatMessage();
  const [project, setProjectData] = useState<ProjectType>({
    id: null,
    created_by: '',
    name: '',
    product_name: '',
    status: null,
    shared_to_groups: [],
    shared_to_users: [],
  });
  const [isLoaded, setIsLoaded] = useState(false);
  const { id } = match.params;

  const getProject = () =>
    api.resources.organization.projects
      .getProject({
        organizationCodename: organization.codename,
        id: id,
      })
      .then(({ data }: { data: ProjectType }) => {
        setProjectData({ ...data });
      })
      .finally(() => {
        setIsLoaded(true);
      });

  useEffect(() => {
    getProject();
    // eslint-disable-next-line
  }, []);

  return (
    <Dashboard title={`Admin / ${project.name}`} location={location}>
      <BackTo onClick={() => history.push(ROUTES.ORGANIZATION.ADMIN.PROJECTS)}>
        <span>
          {`${t('organization.backTo', 'Back to')} ${t(
            'organization.projects',
            'Projects'
          )}`}
        </span>
      </BackTo>
      <Menu tab={tab} selectTab={selectTab} />
      {tab === 'users' && (
        <Users
          organizationCodename={organization.codename}
          projectData={project}
          isLoaded={isLoaded}
          refreshProject={getProject}
        />
      )}
      {tab === 'groups' && (
        <Groups
          organizationCodename={organization.codename}
          projectData={project}
          isLoaded={isLoaded}
          refreshProject={getProject}
        />
      )}
    </Dashboard>
  );
};

export default compose(
  connect((state) => ({
    organization: selectors.authSelectors.userOrganization(state),
    isAdmin: selectors.authSelectors.isOrganizationAdmin(state),
  }))
)(ProjectSharingPage);
